// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1DGWH","input":"styles_input__3pvFi","actions":"styles_actions__Ur3-z","progress":"styles_progress__2M7D4"};